import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';


export interface NotificationConditionBlock {
    title: string;
    conditions: NotificationCondition[]
}



@JsonObject('model.NotificationCondition')
export class NotificationCondition extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'clazz')
    clazz?: string;

    @JsonProperty(Boolean, 'active')
    active?: boolean;

    @JsonProperty(String, 'activeTimeFrom')
  activeTimeFrom?: string;

  @JsonProperty(String, 'activeTimeTo')
  activeTimeTo?: string;

    @JsonProperty(String, 'msg')
    msg?: string;

    @JsonProperty(String, 'title')
    title?: string;
}
